import { render, staticRenderFns } from "./Barra.vue?vue&type=template&id=5b1d2e7c&scoped=true&"
var script = {}
import style0 from "./Barra.vue?vue&type=style&index=0&id=5b1d2e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d2e7c",
  null
  
)

export default component.exports